import { FC, useState } from 'react';
import { twMerge } from 'tailwind-merge';

const AVATAR_COLORS = [
  'bg-[#C2D6FF]',
  'bg-[#F9CBCB]',
  'bg-[#E8E4C7]',
  'bg-[#C7E8D2]',
  'bg-[#DDC7E8]',
];

const avatarColor = (seed: string): string =>
  AVATAR_COLORS[
    [...seed].reduce((total, character) => total + character.charCodeAt(0), 0) %
      AVATAR_COLORS.length
  ];

export type AccessAvatarProps = {
  // The circle's size where it is not the 32px of the access lists; Activity draws it at 24 and 48.
  className?: string;
  label: string;
  labelClassName?: string;
  src?: null | string;
};

export const AccessAvatar: FC<AccessAvatarProps> = ({ className, label, labelClassName, src }) => {
  const [hasImage, setHasImage] = useState(Boolean(src));

  if (src && hasImage) {
    return (
      <img
        alt=""
        className={twMerge('size-8 shrink-0 rounded-full object-cover', className)}
        onError={() => setHasImage(false)}
        src={src}
      />
    );
  }

  return (
    <div
      className={twMerge(
        'flex size-8 shrink-0 items-center justify-center rounded-full',
        avatarColor(label),
        className,
      )}
    >
      <span className={twMerge('text-sm font-medium text-gray-700', labelClassName)}>
        {label.charAt(0).toUpperCase()}
      </span>
    </div>
  );
};
